import { apiPostForm, type ApiResponse } from "@/lib/api";
import type { VoteSubmitData } from "@/lib/types";

// vote_submit.php 전용 제출기.
// 일반 apiPost(URLSearchParams)로는 ans[6][] 같은 «키 반복» 배열을 표현할 수 없어
// FormData 로 보낸다. (multipart 라 PHP 가 배열 파라미터를 그대로 파싱한다)
export function submitVote(
  no: number,
  fields: [string, string][]
): Promise<ApiResponse<VoteSubmitData>> {
  const form = new FormData();
  form.append("no", String(no));
  fields.forEach(([key, value]) => form.append(key, value));
  return apiPostForm<VoteSubmitData>("vote_submit.php", form);
}